import Vue from "vue";
import VueRouter from "vue-router";
import { store } from '../store/index';

Vue.use(VueRouter);

//HOME PAGE VISIBLE FOR ALL CANDIDATES

const Home = () => import(/* webpackChunkName: "home" */'../views/Home.vue');
const Connexion = () => import(/* webpackChunkName: "home" */'../views/Registration.vue');
const Registration = () => import(/* webpackChunkName: "home" */'../views/Connexion.vue');
const PasswordReset = () => import(/* webpackChunkName: "home" */'../views/PasswordReset/index.vue');
const NotFound = () => import(/* webpackChunkName: "home" */'../components/NotFound');
const Contact = () => import(/* webpackChunkName: "home" */'../views/Contact.vue');

//DASHBOARD ONLY FOR SUBSCRIBED MEMBERS OPERATOR COM AC ADMIN

const Dashboard = () => import(/* webpackChunkName: "dashboard" */'../views/dashboard');
const RapidAccess = () => import(/* webpackChunkName: "dashboard" */'../views/dashboard/pages/Rapid_access.vue');


//ADMIN ROUTES
const UserAdd = () => import(/* webpackChunkName: "admin" */'../views/dashboard/pages/admin/UserAdd.vue');
const All_users = () => import(/* webpackChunkName: "admin" */'../views/dashboard/pages/admin/all_users');
const showAllUsers = () => import(/* webpackChunkName: "admin" */'../views/dashboard/pages/admin/all_users/show.vue');
const welcomeAllUsers = () => import(/* webpackChunkName: "admin" */'../views/dashboard/pages/admin/all_users/welcome.vue');
const Access_management = () => import(/* webpackChunkName: "admin" */'../views/dashboard/pages/admin/Accessmanagement.vue');

const visit = () => import(/* webpackChunkName: "visit" */'../views/dashboard/pages/visit');
const showVisit = () => import(/* webpackChunkName: "visit" */'../views/dashboard/pages/visit/show.vue');
const welcomeVisit = () => import(/* webpackChunkName: "visit" */'../views/dashboard/pages/visit/welcome.vue');

const meeting = () => import(/* webpackChunkName: "meeting" */'../views/dashboard/pages/meeting');
const showMeeting = () => import(/* webpackChunkName: "meeting" */'../views/dashboard/pages/meeting/show.vue');
const welcomeMeeting = () => import(/* webpackChunkName: "meeting" */'../views/dashboard/pages/meeting/welcome.vue');

const representator = () => import(/* webpackChunkName: "representator" */'../views/dashboard/pages/representator');
const showRepresentator = () => import(/* webpackChunkName: "representator" */'../views/dashboard/pages/representator/show.vue');
const welcomeRepresentator = () => import(/* webpackChunkName: "representator" */'../views/dashboard/pages/representator/welcome.vue');

const Config = () => import(/* webpackChunkName: "config" */'../views/config');
const confCall = () => import('../views/config/ConfCall.vue');
const message = () => import(/* webpackChunkName: "message" */'../views/dashboard/pages/message');


// ROUTES POUR AUTORITE DE CONTROLE
const Ano_Ppm = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_ppm');
const welcomePpmAno = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_ppm/welcome.vue');
const showPpmAno = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_ppm/show.vue');

const Ano_Avis = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_avis');
const welcomeAvisAno = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_avis/welcome.vue');
const showAvisAno = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_avis/show.vue');

const Ano_Dossier = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_dossier');
const welcomeDossierAno = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_dossier/welcome.vue');
const showDossierAno = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/ano_dossier/show.vue');

const ParticipationSeanceOuv = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_ouv');
const welcomePSeanceOuv = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_ouv/welcome.vue');
const showPSeanceOuv = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_ouv/show.vue');

const ParticipationSeanceEval = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_eval');
const welcomePSeanceEval = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_eval/welcome.vue');
const showPSeanceEval = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_eval/show.vue');

const ParticipationSeanceAttrib = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_attrib');
const welcomePSeanceAttrib = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_attrib/welcome.vue');
const showPSeanceAttrib = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/participation_seance_attrib/show.vue');


const Rapport_Eval = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/rapport_eval');
const welcomeRapportEval = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/rapport_eval/welcome.vue');
const showRapportEval = () => import(/* webpackChunkName: "control" */'../views/dashboard/pages/autority_control/rapport_eval/show.vue');


// ROUTES POUR AUTORITE DE REGULATION
const Reg_recours = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/authrecours');
const RegwelcomeRecours = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/authrecours/welcome.vue');
const RegshowRecours = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/authrecours/show.vue');


const Reg_ppm = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/ppm');
const RegwelcomePpm = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/ppm/welcome.vue');
const RegshowPpm = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/ppm/show.vue');

const Reg_avis = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/avis');
const RegwelcomeAvis = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/avis/welcome.vue');
const RegshowAvis = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/avis/show.vue');

const Reg_dossier = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/dossier');
const RegwelcomeDossier = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/dossier/welcome.vue');
const RegshowDossier = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/dossier/show.vue');

const Reg_Exclusion = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/exclusions');
const RegwelcomeExclusion = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/exclusions/welcome.vue');
const RegshowExclusion = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/exclusions/show.vue');

const Reg_AttestationNonExclusion = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/attestation_non_exclusion');
const RegwelcomeAttestationNonExclusion = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/attestation_non_exclusion/welcome.vue');
const RegshowAttestationNonExclusion = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/attestation_non_exclusion/show.vue');

const Reg_modele_quitus = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/modele_quitus');
const RegwelcomeModele_quitus = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/modele_quitus/welcome.vue');
const RegshowModele_quitus = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/modele_quitus/show.vue');

const Reg_quitus = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/quitus');
const Regwelcome_quitus = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/quitus/welcome.vue');
const Regshow_quitus = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/quitus/show.vue');

const Reg_denonciation = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/all_denonciations');
const Regwelcome_denonciation = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/all_denonciations/welcome.vue');
const Regshow_denonciation = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/all_denonciations/show.vue');

const Reg_sollicitation = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/all_sollicitations');
const Regwelcome_sollicitation = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/all_sollicitations/welcome.vue');
const Regshow_sollicitation = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/all_sollicitations/show.vue');

const RegSeanceOuv = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_ouv');
const RegwelcomeSeanceOuv = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_ouv/welcome.vue');
const RegshowSeanceOuv = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_ouv/show.vue');

const RegSeanceEval = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_eval');
const RegwelcomeSeanceEval = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_eval/welcome.vue');
const RegshowSeanceEval = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_eval/show.vue');

const RegSeanceAttrib = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_attrib');
const RegwelcomeSeanceAttrib = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_attrib/welcome.vue');
const RegshowSeanceAttrib = () => import(/* webpackChunkName: "regulation" */'../views/dashboard/pages/autority_regulation/seance_attrib/show.vue');


// -------------------------------------------------------- DASHBOARD

// ----------------- ADMIN GLOBAL ROUTES

// ----------------- AC GLOBAL ROUTES

// ANO ROUTES
const ano = () => import('../views/dashboard/pages/ano');
const showAno = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/show.vue');
const welcomeAno = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/welcome.vue');

// PPM ANO FOR AC
const ano_ppm_ac = () => import('../views/dashboard/pages/ano/ano_ppm_ac');
const showPpmAnoAc = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/ano_ppm_ac/show.vue');
const welcomePpmAnoAc = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/ano_ppm_ac/welcome.vue');

// AVIS ANO FOR AC
const envoi_avis_ac = () => import('../views/dashboard/pages/ano/envoi_avis_ac');
const showAvisEnvoiAc = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/envoi_avis_ac/show.vue');
const welcomeAvisEnvoiAc = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/envoi_avis_ac/welcome.vue');

// DOSSIER ANO FOR AC
const ano_dossier_ac = () => import('../views/dashboard/pages/ano/ano_dossier_ac');
const showDossierAnoAc = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/ano_dossier_ac/show.vue');
const welcomeDossierAnoAc = () => import(/* webpackChunkName: "ano" */'../views/dashboard/pages/ano/ano_dossier_ac/welcome.vue');


// PPM ROUTES
const ppm = () => import(/* webpackChunkName: "ppm" */'../views/dashboard/pages/ppm');
const showPpm = () => import(/* webpackChunkName: "ppm" */'../views/dashboard/pages/ppm/show.vue');
const welcomePpm = () => import(/* webpackChunkName: "ppm" */'../views/dashboard/pages/ppm/welcome.vue');

// RECOURSE
const Recourse = () => import(/* webpackChunkName: "recourse" */'../views/Public/recourse');
const showRecourse = () => import(/* webpackChunkName: "recourse" */'../views/Public/recourse/show.vue');
const welcomeRecourse = () => import(/* webpackChunkName: "recourse" */'../views/Public/recourse/welcome.vue');

// FOLDER ROUTES
const folder = () => import(/* webpackChunkName: "folder" */'../views/dashboard/pages/folder');
const welcomeFolder = () => import(/* webpackChunkName: "folder" */'../views/dashboard/pages/folder/welcome.vue');
const showFolder = () => import(/* webpackChunkName: "folder" */'../views/dashboard/pages/folder/show.vue');

// NOTICE ROUTES
const notice = () => import(/* webpackChunkName: "notice" */'../views/dashboard/pages/notice');
const showNotice = () => import(/* webpackChunkName: "notice" */'../views/dashboard/pages/notice/show.vue');
const welcomeNotice = () => import(/* webpackChunkName: "notice" */'../views/dashboard/pages/notice/welcome.vue');

// COMMISSION ROUTES
const commission = () => import(/* webpackChunkName: "commission" */'../views/dashboard/pages/commission');
const welcomeCommission = () => import(/* webpackChunkName: "commission" */'../views/dashboard/pages/commission/welcome');
const showCommission = () => import(/* webpackChunkName: "commission" */'../views/dashboard/pages/commission/show');

// OPERATOR FOLDERS ROUTES

const mes_attestations = () => import(/* webpackChunkName: "opfolder" */'../views/dashboard/pages/mes_attestations');
const welcome_mes_attestations = () => import(/* webpackChunkName: "opfolder" */'../views/dashboard/pages/mes_attestations/welcome.vue');
const show_mes_attestations = () => import(/* webpackChunkName: "opfolder" */'../views/dashboard/pages/mes_attestations/show.vue');


const OpFolder = () => import(/* webpackChunkName: "opfolder" */'../views/dashboard/pages/op/folder');
const welcomeOpFolder = () => import(/* webpackChunkName: "opfolder" */'../views/dashboard/pages/op/folder/welcome.vue');
const showOpFolder = () => import(/* webpackChunkName: "opfolder" */'../views/dashboard/pages/op/folder/show.vue');
const showGiveAccess = () => import(/* webpackChunkName: "opfolder" */'../views/dashboard/pages/op/folder/showGiveAccess.vue');

// REQUEST ROUTES
const request = () => import(/* webpackChunkName: "request" */'../views/dashboard/pages/request');
const welcomeRequest = () => import(/* webpackChunkName: "request" */'../views/dashboard/pages/request/welcome.vue');
const showRequest = () => import(/* webpackChunkName: "request" */'../views/dashboard/pages/request/show.vue');
const showRequestResponse = () => import(/* webpackChunkName: "request" */'../views/dashboard/pages/request/showResponse.vue');

// OFFERS ROUTES
const Offers = () => import(/* webpackChunkName: "offer" */'../views/dashboard/pages/offers');
const showOffers = () => import(/* webpackChunkName: "offer" */'../views/dashboard/pages/offers/show.vue');
const welcomeOffers = () => import(/* webpackChunkName: "offer" */'../views/dashboard/pages/offers/welcome.vue');
const requestOffers = () => import(/* webpackChunkName: "offer" */'../views/dashboard/pages/offers/request');

const Session = () => import(/* webpackChunkName: "session" */'../views/dashboard/pages/session');
const showSession = () => import(/* webpackChunkName: "session" */'../views/dashboard/pages/session/show.vue');
const welcomeSession = () => import(/* webpackChunkName: "session" */'../views/dashboard/pages/session/welcome.vue');

const Model_pv = () => import(/* webpackChunkName: "pv" */'../views/dashboard/pages/model_pv');
const showModel_pv = () => import(/* webpackChunkName: "pv" */'../views/dashboard/pages/model_pv/show.vue');
const welcomeModel_pv = () => import(/* webpackChunkName: "pv" */'../views/dashboard/pages/model_pv/welcome.vue');

const Attribution = () => import(/* webpackChunkName: "attribution" */'../views/dashboard/pages/attribution');
const showAttribution = () => import(/* webpackChunkName: "attribution" */'../views/dashboard/pages/attribution/show.vue');
const welcomeAttribution = () => import(/* webpackChunkName: "attribution" */'../views/dashboard/pages/attribution/welcome.vue');

const Contract = () => import(/* webpackChunkName: "contract" */'../views/dashboard/pages/contract');
const showContract = () => import(/* webpackChunkName: "contract" */'../views/dashboard/pages/contract/show.vue');
const welcomeContract = () => import(/* webpackChunkName: "contract" */'../views/dashboard/pages/contract/welcome.vue');

const evaluation = () => import(/* webpackChunkName: "evaluation" */'../views/dashboard/pages/evaluation');
const showEvaluation = () => import(/* webpackChunkName: "evaluation" */'../views/dashboard/pages/evaluation/show.vue');
const welcomeEvaluation = () => import(/* webpackChunkName: "evaluation" */'../views/dashboard/pages/evaluation/welcome.vue');

// EXCLUSIONS ROUTES
const entreprises_exclues = () => import(/* webpackChunkName: "entreprises_exclues" */'../views/dashboard/pages/entreprises_exclues');
const welcome_entreprises_exclues = () => import(/* webpackChunkName: "entreprises_exclues" */'../views/dashboard/pages/entreprises_exclues/welcome.vue');
const show_entreprises_exclues = () => import(/* webpackChunkName: "entreprises_exclues" */'../views/dashboard/pages/entreprises_exclues/show.vue');

//Modele de fiche d'attestation de non exclusion
const modele_fiche_quitus = () => import(/* webpackChunkName: "modele_fiche_quitus" */'../views/dashboard/pages/modele_fiche_quitus');
const welcome_modele_fiche_quitus = () => import(/* webpackChunkName: "modele_fiche_quitus" */'../views/dashboard/pages/modele_fiche_quitus/welcome.vue');
const show_modele_fiche_quitus = () => import(/* webpackChunkName: "modele_fiche_quitus" */'../views/dashboard/pages/modele_fiche_quitus/show.vue');

const quitus_non_redevance = () => import(/* webpackChunkName: "quitus_non_redevance" */'../views/dashboard/pages/quitus_non_redevance');
const welcome_quitus_non_redevance = () => import(/* webpackChunkName: "quitus_non_redevance" */'../views/dashboard/pages/quitus_non_redevance/welcome.vue');
const show_quitus_non_redevance = () => import(/* webpackChunkName: "quitus_non_redevance" */'../views/dashboard/pages/quitus_non_redevance/show.vue');

const mes_denonciations = () => import(/* webpackChunkName: "mes_denonciations" */'../views/dashboard/pages/mes_denonciations');
const welcome_mes_denonciations = () => import(/* webpackChunkName: "mes_denonciations" */'../views/dashboard/pages/mes_denonciations/welcome.vue');
const show_mes_denonciations = () => import(/* webpackChunkName: "mes_denonciations" */'../views/dashboard/pages/mes_denonciations/show.vue');

const mes_sollicitations = () => import(/* webpackChunkName: "mes_sollicitations" */'../views/dashboard/pages/mes_sollicitations');
const welcome_mes_sollicitations = () => import(/* webpackChunkName: "mes_sollicitations" */'../views/dashboard/pages/mes_sollicitations/welcome.vue');
const show_mes_sollicitations = () => import(/* webpackChunkName: "mes_sollicitations" */'../views/dashboard/pages/mes_sollicitations/show.vue');


// ----------------- OPERATOR GLOBAL ROUTES

// -------------------------------------------------------- HOME

// PUBLIC NOTICE ROUTES

const show_p_ppm = () => import(/* webpackChunkName: "publicppm" */'../views/Public/ppm/show.vue');
const public_ppm = () => import(/* webpackChunkName: "publicppm" */'../views/Public/ppm');
const welcome_ppm_public = () => import(/* webpackChunkName: "publicppm" */'../views/Public/ppm/welcome.vue');

const public_notice = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice');
const show_p_notice = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/show.vue');
const welcome_p_notice = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/welcome.vue');

const noticeType1 = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/noticeType/1.vue');
const noticeType2 = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/noticeType/2.vue');
const noticeType3 = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/noticeType/3.vue');
const noticeType4 = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/noticeType/4.vue');
const noticeType5 = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/noticeType/5.vue');
const noticeType6 = () => import(/* webpackChunkName: "publicnotice" */'../views/Public/notice/noticeType/6.vue');

const public_exclusion = () => import(/* webpackChunkName: "publicexclusion" */'../views/Public/list_excluded');
const show_public_exclusion = () => import(/* webpackChunkName: "publicexclusion" */'../views/Public/list_excluded/show.vue');
const welcome_public_exclusion = () => import(/* webpackChunkName: "publicexclusion" */'../views/Public/list_excluded/welcome.vue');

const public_denonciation = () => import(/* webpackChunkName: "public_denonciation" */'../views/Public/public_denonciation');
const show_public_denonciation = () => import(/* webpackChunkName: "public_denonciation" */'../views/Public/public_denonciation/show.vue');
const welcome_public_denonciation = () => import(/* webpackChunkName: "public_denonciation" */'../views/Public/public_denonciation/welcome.vue');

// Fonction pour sécurisée une route si l 'utilisateur n'a pas de session active

function guardAdmin(to, from, next) {
  // Verification du token
  if (localStorage.getItem('icp_pass') && store.getters['Auth/isActive']) {
    next();
  } else {
    next({ name: "Connexion" });
  }
}
function guardClient(to, from, next) {
  // Verification du token
  if (localStorage.getItem('icp_pass') && store.getters['Auth/isActive']) {
    next({ name: "Dashboard" });
  } else {
    next();
  }
}

const routes = [
  {
    path: "/",
    name: "Accueil",
    component: Home,
    meta: {
      title: 'Accueil | ICP-E-PROCUREMENT',
      metaTags: [
        {
          name: 'description',
          content: "La passation des marchés publics est l'une des activités gouvernementales les plus vulnérables à la corruption. Outre le volume des transactions et les intérêts financiers en jeu, comme rappelé ci-dessus, les risques de corruption "
        },
        {
          property: 'og:description',
          content: "La passation des marchés publics est l'une des activités gouvernementales les plus vulnérables à la corruption. Outre le volume des transactions et les intérêts financiers en jeu, comme rappelé ci-dessus, les risques de corruption "
        }
      ]
    }
  },
  {
    path: "/connexion",
    name: "Connexion",
    component: Connexion,
    beforeEnter: guardClient,
    meta: {
      title: 'Connexion | ICP-E-PROCUREMENT',
      metaTags: [
        {
          name: 'description',
          content: "Page pour s'authentifier at acceder à son espace."
        },
        {
          property: 'og:description',
          content: "Page pour s'authentifier at acceder à son espace."
        }
      ]
    }
  },
  {
    path: "/registration",
    name: "Registration",
    component: Registration,
    beforeEnter: guardClient,
    meta: {
      title: 'Inscription | ICP-E-PROCUREMENT',
      metaTags: [
        {
          name: 'description',
          content: "Page pour la création de compte "
        },
        {
          property: 'og:description',
          content: "Page pour la création de compte"
        }
      ]
    }
  },
  {
    path: "/dashboard",
    component: Dashboard,
    name: "Dashboard",
    meta: {
      title: 'Tableau de bord | ICP-E-PROCUREMENT',
      metaTags: [
        {
          name: 'description',
          content: "Espace sécurisée"
        },
        {
          property: 'og:description',
          content: "Espace sécurisée"
        }
      ],
      breadcrumb: 'Tableau de bord'
    },
    redirect: { name: "RapidAccess" },
    beforeEnter: guardAdmin,
    children: [
      {
        path: "visit",
        name: "visit",
        component: visit,
        meta: {
          title: 'Visite de site | ICP-E-PROCUREMENT',
          metaTags: [
            {
              name: 'description',
              content: "Les visites de sites"
            },
            {
              property: 'og:description',
              content: "Les visites de sites"
            }
          ],
          breadcrumb: 'Liste des visites de site '
        },
        redirect: { name: "welcomeVisit" },
        children: [
          {
            path: "",
            name: "welcomeVisit",
            component: welcomeVisit
          },
          {
            meta: {
              breadcrumb: 'Aperçu de la visite de site'
            },
            path: ":id",
            name: "showVisit",
            props: true,
            component: showVisit
          }
        ]
      },
      {
        path: "evaluation",
        name: "Evaluation",
        component: evaluation,
        meta: {
          title: 'Evaluation | ICP-E-PROCUREMENT',
          metaTags: [
            {
              name: 'description',
              content: "Les évaluations"
            },
            {
              property: 'og:description',
              content: "Les évaluations"
            }
          ],
          breadcrumb: 'LISTE DES SEANCES D’EVALUATIONS DES OFFRES/PROPOSITIONS/PLIS '
        },
        redirect: { name: "welcomeEvaluation" },
        children: [
          {
            path: "",
            name: "welcomeEvaluation",
            component: welcomeEvaluation
          },
          {
            meta: {
              breadcrumb: 'Aperçu de la séance d’évaluation des Offres/Propositions/Plis/Manifestations d’Intérêts/Pré-qualifications '
            },
            path: ":id",
            name: "showEvaluation",
            props: true,
            component: showEvaluation
          }
        ]
      },
      {
        path: "meeting",
        name: "meeting",
        component: meeting,
        meta: {
          title: 'Conférence Préalable | ICP-E-PROCUREMENT',
          metaTags: [
            {
              name: 'description',
              content: "Les Conférences préalable"
            },
            {
              property: 'og:description',
              content: "Les Conférences préalable"
            }
          ],
          breadcrumb: 'Liste des Conférences préalables'
        },
        redirect: { name: "welcomeMeeting" },
        children: [
          {
            path: "",
            name: "welcomeMeeting",
            component: welcomeMeeting
          },
          {
            meta: {
              breadcrumb: 'Aperçu de la conférence préalable'
            },
            path: ":id",
            name: "showMeeting",
            props: true,
            component: showMeeting
          }
        ]
      },
      {
        name: "RapidAccess",
        path: "",
        component: RapidAccess
      },
      {
        meta: {
          title: 'Reunion en ligne | ICP-E-PROCUREMENT',
          metaTags: [
            {
              name: 'description',
              content: "Séance de Visio-conférence"
            },
            {
              property: 'og:description',
              content: "Séance de Visio-conférence"
            }
          ],
          breadcrumb: 'Séance de Visio-conférence'
        },
        name: "confCall",
        path: "confCall",
        component: confCall
      },
      {
        meta: {
          breadcrumb: 'Configuration des informations de la page d’accueil'
        },
        name: "Config",
        path: "config",
        component: Config
      },
      {
        path: "ano",
        name: "ano",
        component: ano,
        meta: {
          breadcrumb: 'Liste des options en rapport avec l\'organe de contrôle'
        },
        redirect: { name: "welcomeAno" },
        children: [
          {
            path: "",
            name: "welcomeAno",
            component: welcomeAno,
          },
          {
            path: ":id",
            name: "showAno",
            props: true,
            component: showAno,
            meta: {
              breadcrumb: 'Aperçu de l\'envoi d\'une demande pour ANO'
            }
          }
        ]
      },
      {
        path: "ano_ppm_ac",
        name: "ano_ppm_ac",
        component: ano_ppm_ac,
        meta: {
          breadcrumb: 'Liste des options en rapport avec l\'organe de contrôle'
        },
        redirect: { name: "welcomePpmAnoAc" },
        
        children: [
          {
            path: "",
            name: "welcomePpmAnoAc",
            component: welcomePpmAnoAc,
            meta: {
              breadcrumb: 'PPM'
            },
          },
          {
            path: ":id",
            name: "showPpmAnoAc",
            props: true,
            component: showPpmAnoAc,
            meta: {
              breadcrumb: 'Aperçu de l\'envoi d\'une demande pour ANO'
            }
          }
        ]
      },
      {
        path: "envoi_avis_ac",
        name: "envoi_avis_ac",
        component: envoi_avis_ac,
        meta: {
          breadcrumb: 'Liste des options en rapport avec l\'organe de contrôle'
        },
        redirect: { name: "welcomeAvisEnvoiAc" }, 
        children: [
          {
            path: "",
            name: "welcomeAvisEnvoiAc",
            component: welcomeAvisEnvoiAc,
          },
          {
            path: ":id",
            name: "showAvisEnvoiAc",
            props: true,
            component: showAvisEnvoiAc,
            meta: {
              breadcrumb: 'Aperçu de l\'envoi d\'une demande pour ANO'
            }
          }
        ]
      },
      {
        path: "ano_dossier_ac",
        name: "ano_dossier_ac",
        component: ano_dossier_ac,
        meta: {
          breadcrumb: 'Liste des options en rapport avec l\'organe de contrôle'
        },
        redirect: { name: "welcomeDossierAnoAc" },
        children: [
          {
            path: "",
            name: "welcomeDossierAnoAc",
            component: welcomeDossierAnoAc,
          },
          {
            path: ":id",
            name: "showDossierAnoAc",
            props: true,
            component: showDossierAnoAc,
            meta: {
              breadcrumb: 'Aperçu de l\'envoi d\'une demande pour ANO'
            }
          }
        ]
      },
      {
        path: "ppm",
        name: "ppm",
        component: ppm,
        meta: {
          breadcrumb: 'Liste des Plans de Passation des Marchés (PPM)'
        },
        redirect: { name: "welcomePpm" },
        children: [
          {
            path: "",
            name: "welcomePpm",
            component: welcomePpm,
          },
          {
            path: ":id",
            name: "showPpm",
            props: true,
            component: showPpm,
            meta: {
              breadcrumb: 'Aperçu du Plan de Passation des Marchés (PPM)'
            }
          }
        ]
      },
      {
        meta: {
          breadcrumb: 'Demandes de  renseignement'
        },
        path: "message",
        name: "message",
        component: message
      },
      {
        meta: {
          breadcrumb: 'Création de compte'
        },
        path: "UserAdd",
        name: "UserAdd",
        component: UserAdd
      },
      {
        meta: {
          breadcrumb: 'Gestion de compte'
        },
        path: "All_users",
        name: "All_users",
        component: All_users,
        redirect: { name: "welcomeAllUsers" },
        children: [
          {
            path: "",
            name: "welcomeAllUsers",
            component: welcomeAllUsers
          },
          {
            meta: {
              breadcrumb: 'Aperçu du compte'
            },
            path: ":id",
            name: "showAllUsers",
            props: true,
            component: showAllUsers
          }
        ]
      },
      {
        meta: {
          breadcrumb: 'Abréviation/Acronyme'
        },
        path: "Access_management",
        name: "Access_management",
        component: Access_management
      },
      {
        path: "ano_ppm",
        name: "ano_ppm",
        component: Ano_Ppm,
        meta: {
          breadcrumb: 'Liste des Plans de Passation des Marchés (PPM)'
        },
        redirect: { name: "welcomePpmAno" },
        children: [
          {
            path: "",
            name: "welcomePpmAno",
            component: welcomePpmAno
          },
          {
            path: ":id",
            name: "showPpmAno",
            props: true,
            component: showPpmAno,
            meta: {
              breadcrumb: 'Aperçu du Plan de Passation des Marchés (PPM)'
            }
          }
        ]
      },
      {
        path: "ano_avis",
        name: "ano_avis",
        component: Ano_Avis,
        meta: {
          breadcrumb: 'Liste détaillé des avis d\'appel à concurrence'
        },
        redirect: { name: "welcomeAvisAno" },
        children: [
          {
            path: "",
            name: "welcomeAvisAno",
            component: welcomeAvisAno
          },
          {
            path: ":id",
            name: "showAvisAno",
            props: true,
            component: showAvisAno,
            meta: {
              breadcrumb: 'Aperçu de l\'avis d\'appel à concurrence'
            }
          }
        ]
      },
      {
        path: "ano_dossier",
        name: "ano_dossier",
        component: Ano_Dossier,
        meta: {
          breadcrumb: 'Liste détaillé des dossiers d\'appel à concurrence'
        },
        redirect: { name: "welcomeDossierAno" },
        children: [
          {
            path: "",
            name: "welcomeDossierAno",
            component: welcomeDossierAno
          },
          {
            path: ":id",
            name: "showDossierAno",
            props: true,
            component: showDossierAno,
            meta: {
              breadcrumb: 'Aperçu du dossier d\'appel à concurrence'
            }
          }
        ]
      },
      {
        path: "participation_seance_ouv",
        name: "participation_seance_ouv",
        component: ParticipationSeanceOuv,
        meta: {
          breadcrumb: 'Participation aux séances d\'ouverture des offres',
        },
        redirect: { name: "welcomePSeanceOuv" },
        children: [
          {
            path: "",
            name: "welcomePSeanceOuv",
            component: welcomePSeanceOuv
          },
          {
            path: ":id",
            name: "showPSeanceOuv",
            props: true,
            component: showPSeanceOuv,
            meta: {
              breadcrumb: 'Aperçu de la séance'
            }
          }
        ]
      },
      {
        path: "participation_seance_eval",
        name: "participation_seance_eval",
        component: ParticipationSeanceEval,
        meta: {
          breadcrumb: 'Participation aux séances d\'evaluation des offres',
        },
        redirect: { name: "welcomePSeanceEval" },
        children: [
          {
            path: "",
            name: "welcomePSeanceEval",
            component: welcomePSeanceEval
          },
          {
            path: ":id",
            name: "showPSeanceEval",
            props: true,
            component: showPSeanceEval,
            meta: {
              breadcrumb: 'Aperçu de la séance d\'evaluation'
            }
          }
        ]
      },
      {
        path: "participation_seance_attrib",
        name: "participation_seance_attrib",
        component: ParticipationSeanceAttrib,
        meta: {
          breadcrumb: 'Participation aux séances d\'attribution du marché',
        },
        redirect: { name: "welcomePSeanceAttrib" },
        children: [
          {
            path: "",
            name: "welcomePSeanceAttrib",
            component: welcomePSeanceAttrib
          },
          {
            path: ":id",
            name: "showPSeanceAttrib",
            props: true,
            component: showPSeanceAttrib,
            meta: {
              breadcrumb: 'Aperçu de la séance d\'attribution'
            }
          }
        ]
      },
      {
        path: "rapport_eval",
        name: "rapport_eval",
        component: Rapport_Eval,
        meta: {
          breadcrumb: 'Liste des rapports d\'evaluations',
        },
        redirect: { name: "welcomeRapportEval" },
        children: [
          {
            path: "",
            name: "welcomeRapportEval",
            component: welcomeRapportEval
          },
          {
            path: ":id",
            name: "showRapportEval",
            props: true,
            component: showRapportEval,
            meta: {
              breadcrumb: 'Aperçu du rapport'
            }
          }
        ]
      },
      /* AUTORITE DE REGULATION */ 
      {
        path: "Reg_recours",
        name: "Reg_recours",
        component: Reg_recours,
        meta: {
          breadcrumb: 'Liste des recours',
        },
        redirect: { name: "RegwelcomeRecours" },
        children: [
          {
            path: "",
            name: "RegwelcomeRecours",
            component: RegwelcomeRecours
          },
          {
            path: ":id",
            name: "RegshowRecours",
            props: true,
            component: RegshowRecours,
            meta: {
              breadcrumb: 'Aperçu du recours'
            }
          }
        ]
      },
      {
        path: "Reg_ppm",
        name: "Reg_ppm",
        component: Reg_ppm,
        meta: {
          breadcrumb: 'Liste des ppm publiés',
        },
        redirect: { name: "RegwelcomePpm" },
        children: [
          {
            path: "",
            name: "RegwelcomePpm",
            component: RegwelcomePpm
          },
          {
            path: ":id",
            name: "RegshowPpm",
            props: true,
            component: RegshowPpm,
            meta: {
              breadcrumb: 'Aperçu du ppm'
            }
          }
        ]
      },
      {
        path: "Reg_avis",
        name: "Reg_avis",
        component: Reg_avis,
        meta: {
          breadcrumb: 'Liste des avis publiés',
        },
        redirect: { name: "RegwelcomeAvis" },
        children: [
          {
            path: "",
            name: "RegwelcomeAvis",
            component: RegwelcomeAvis
          },
          {
            path: ":id",
            name: "RegshowAvis",
            props: true,
            component: RegshowAvis,
            meta: {
              breadcrumb: 'Aperçu des avis'
            }
          }
        ]
      },
      {
        path: "Reg_dossier",
        name: "Reg_dossier",
        component: Reg_dossier,
        meta: {
          breadcrumb: 'Liste des dossiers publiés',
        },
        redirect: { name: "RegwelcomeDossier" },
        children: [
          {
            path: "",
            name: "RegwelcomeDossier",
            component: RegwelcomeDossier
          },
          {
            path: ":id",
            name: "RegshowDossier",
            props: true,
            component: RegshowDossier,
            meta: {
              breadcrumb: 'Aperçu des dossiers'
            }
          }
        ]
      },
      {
        path: "Reg_Exclusion",
        name: "Reg_Exclusion",
        component: Reg_Exclusion,
        meta: {
          breadcrumb: 'Liste des entreprises  exclues',
        },
        redirect: { name: "RegwelcomeExclusion" },
        children: [
          {
            path: "",
            name: "RegwelcomeExclusion",
            component: RegwelcomeExclusion
          },
          {
            path: ":id",
            name: "RegshowExclusion",
            props: true,
            component: RegshowExclusion,
            meta: {
              breadcrumb: 'Détails de l\'entreprise'
            }
          }
        ]
      },
      {
        path: "Reg_AttestationNonExclusion",
        name: "Reg_AttestationNonExclusion",
        component: Reg_AttestationNonExclusion,
        meta: {
          breadcrumb: 'Liste des demandes d\'attestation de non exclusion',
        },
        redirect: { name: "RegwelcomeAttestationNonExclusion" },
        children: [
          {
            path: "",
            name: "RegwelcomeAttestationNonExclusion",
            component: RegwelcomeAttestationNonExclusion
          },
          {
            path: ":id",
            name: "RegshowAttestationNonExclusion",
            props: true,
            component: RegshowAttestationNonExclusion,
            meta: {
              breadcrumb: 'Détails de la demande d\'attestation'
            }
          }
        ]
      },
      {
        path: "Reg_modele_quitus",
        name: "Reg_modele_quitus",
        component: Reg_modele_quitus,
        meta: {
          breadcrumb: 'Modèles de fiche de quitus de non redevance',
        },
        redirect: { name: "RegwelcomeModele_quitus" },
        children: [
          {
            path: "",
            name: "RegwelcomeModele_quitus",
            component: RegwelcomeModele_quitus
          },
          {
            path: ":id",
            name: "RegshowModele_quitus",
            props: true,
            component: RegshowModele_quitus,
            meta: {
              breadcrumb: 'Fiche de demande de quitus'
            }
          }
        ]
      },
      {
        path: "Reg_quitus",
        name: "Reg_quitus",
        component: Reg_quitus,
        meta: {
          breadcrumb: 'Liste des demandes de quitus de non redevance',
        },
        redirect: { name: "Regwelcome_quitus" },
        children: [
          {
            path: "",
            name: "Regwelcome_quitus",
            component: Regwelcome_quitus
          },
          {
            path: ":id",
            name: "Regshow_quitus",
            props: true,
            component: Regshow_quitus,
            meta: {
              breadcrumb: 'Quitus de non redevance'
            }
          }
        ]
      },
      {
        path: "Reg_denonciation",
        name: "Reg_denonciation",
        component: Reg_denonciation,
        meta: {
          breadcrumb: 'Liste des dénonciations',
        },
        redirect: { name: "Regwelcome_denonciation" },
        children: [
          {
            path: "",
            name: "Regwelcome_denonciation",
            component: Regwelcome_denonciation
          },
          {
            path: ":id",
            name: "Regshow_denonciation",
            props: true,
            component: Regshow_denonciation,
            meta: {
              breadcrumb: 'Détail de la dénonciation'
            }
          }
        ]
      },
      {
        path: "Reg_sollicitation",
        name: "Reg_sollicitation",
        component: Reg_sollicitation,
        meta: {
          breadcrumb: 'Liste des sollicitations',
        },
        redirect: { name: "Regwelcome_sollicitation" },
        children: [
          {
            path: "",
            name: "Regwelcome_sollicitation",
            component: Regwelcome_sollicitation
          },
          {
            path: ":id",
            name: "Regshow_sollicitation",
            props: true,
            component: Regshow_sollicitation,
            meta: {
              breadcrumb: 'Détail de la sollicitation'
            }
          }
        ]
      },

      {
        path: "RegSeanceOuv",
        name: "RegSeanceOuv",
        component: RegSeanceOuv,
        meta: {
          breadcrumb: 'Participation aux séances d\'ouverture des offres',
        },
        redirect: { name: "RegwelcomeSeanceOuv" },
        children: [
          {
            path: "",
            name: "RegwelcomeSeanceOuv",
            component: RegwelcomeSeanceOuv
          },
          {
            path: ":id",
            name: "RegshowSeanceOuv",
            props: true,
            component: RegshowSeanceOuv,
            meta: {
              breadcrumb: 'Aperçu de la séance'
            }
          }
        ]
      },
      {
        path: "RegSeanceEval",
        name: "RegSeanceEval",
        component: RegSeanceEval,
        meta: {
          breadcrumb: 'Participation aux séances d\'evaluation des offres',
        },
        redirect: { name: "RegwelcomeSeanceEval" },
        children: [
          {
            path: "",
            name: "RegwelcomeSeanceEval",
            component: RegwelcomeSeanceEval
          },
          {
            path: ":id",
            name: "RegshowSeanceEval",
            props: true,
            component: RegshowSeanceEval,
            meta: {
              breadcrumb: 'Aperçu de la séance d\'evaluation'
            }
          }
        ]
      },
      {
        path: "RegSeanceAttrib",
        name: "RegSeanceAttrib",
        component: RegSeanceAttrib,
        meta: {
          breadcrumb: 'Participation aux séances d\'attribution du marché',
        },
        redirect: { name: "RegwelcomeSeanceAttrib" },
        children: [
          {
            path: "",
            name: "RegwelcomeSeanceAttrib",
            component: RegwelcomeSeanceAttrib
          },
          {
            path: ":id",
            name: "RegshowSeanceAttrib",
            props: true,
            component: RegshowSeanceAttrib,
            meta: {
              breadcrumb: 'Aperçu de la séance d\'attribution'
            }
          }
        ]
      },

      /* FIN AUTORITE DE REGULATION */
      {
        meta: {
          breadcrumb: 'Liste de Commissions'
        },
        path: "commission",
        name: "commission",
        component: commission,
        redirect: { name: "welcomeCommission" },
        children: [
          {
            path: "",
            name: "welcomeCommission",
            component: welcomeCommission
          },
          {
            meta: {
              breadcrumb: 'Aperçu et configuration des  membres de la commission'
            },
            path: ":id",
            name: "showCommission",
            props: true,
            component: showCommission
          }
        ]
      },
      {
        path: "notice",
        name: "notice",
        component: notice,
        meta: {
          breadcrumb: 'Liste des Avis'
        },
        redirect: { name: "welcomeNotice" },
        children: [
          {
            path: "",
            name: "welcomeNotice",
            component: welcomeNotice
          },
          {
            meta: {
              breadcrumb: 'Aperçu de l’avis publié'
            },
            path: ":id",
            name: "showNotice",
            props: true,
            component: showNotice
          }
        ]
      },
      {
        meta: {
          breadcrumb: 'CONSULTER ET TELECHARGER DES DEMANDES D’ECLAIRCISSEMENTS'
        },
        path: "request",
        name: "request",
        component: request,
        redirect: { name: "welcomeRequest" },
        children: [
          {
            path: "",
            name: "welcomeRequest",
            component: welcomeRequest
          },
          {
            meta: {
              breadcrumb: 'Aperçu de la demande d’éclaircissements'
            },
            path: ":id",
            name: "showRequest",
            props: true,
            component: showRequest,
          }
        ]
      },
      {
        meta: {
          breadcrumb: 'Réponse à la Demandes d’éclaircissement'
        },
        path: "response/:id",
        name: "showRequestResponse",
        props: true,
        component: showRequestResponse
      },
      {
        path: "mes_attestations",
        name: "mes_attestations",
        meta: {
          breadcrumb: 'LISTE DES DEMANDES D\'ATTESTATION'
        },
        component: mes_attestations,
        redirect: { name: "welcome_mes_attestations" },
        children: [
          {
            path: "",
            name: "welcome_mes_attestations",
            component: welcome_mes_attestations
          },
          {
            meta: {
              breadcrumb: 'Aperçu de la demande d\'attestation'
            },
            path: ":id",
            name: "show_mes_attestations",
            props: true,
            component: show_mes_attestations
          }
        ]
      },
      {
        path: "mes_denonciations",
        name: "mes_denonciations",
        meta: {
          breadcrumb: 'LISTE DES DENONCIATIONS'
        },
        component: mes_denonciations,
        redirect: { name: "welcome_mes_denonciations" },
        children: [
          {
            path: "",
            name: "welcome_mes_denonciations",
            component: welcome_mes_denonciations
          },
          {
            meta: {
              breadcrumb: 'Aperçu de la dénonciation'
            },
            path: ":id",
            name: "show_mes_denonciations",
            props: true,
            component: show_mes_denonciations
          }
        ]
      },
      {
        path: "mes_sollicitations",
        name: "mes_sollicitations",
        meta: {
          breadcrumb: 'LISTE DES SOLLICITATIONS DE CONCILIATION'
        },
        component: mes_sollicitations,
        redirect: { name: "welcome_mes_sollicitations" },
        children: [
          {
            path: "",
            name: "welcome_mes_sollicitations",
            component: welcome_mes_sollicitations
          },
          {
            meta: {
              breadcrumb: 'Aperçu de la sollicitation'
            },
            path: ":id",
            name: "show_mes_sollicitations",
            props: true,
            component: show_mes_sollicitations
          }
        ]
      },
      {
        path: "OpFolder",
        name: "OpFolder",
        meta: {
          breadcrumb: 'LISTE DES DOSSIERS DE CONSULTATION'
        },
        component: OpFolder,
        redirect: { name: "welcomeOpFolder" },
        children: [
          {
            path: "",
            name: "welcomeOpFolder",
            component: welcomeOpFolder
          },
          {
            meta: {
              breadcrumb: 'Aperçu du dossier d’appel à la concurrence'
            },
            path: ":id",
            name: "showOpFolder",
            props: true,
            component: showOpFolder
          },
          {
            meta: {
              breadcrumb: 'Paramétrage de l’accès aux dossiers après paiement'
            },
            path: ":id",
            name: "showGiveAccess",
            props: true,
            component: showGiveAccess
          },
        ]
      },
      {
        path: "folder",
        name: "folder",
        component: folder,
        redirect: { name: "welcomeFolder" },
        meta: {
          breadcrumb: 'LISTE DES DOSSIERS DE CONSULTATION'
        },
        children: [
          {
            path: "",
            name: "welcomeFolder",
            component: welcomeFolder
          },
          {
            meta: {
              breadcrumb: 'Aperçu du dossier d’appel à la concurrence'
            },
            path: ":id",
            name: "showFolder",
            props: true,
            component: showFolder
          }
        ]
      },
      {
        meta: {
          breadcrumb: "Liste des Offre/Propositions/Réponses aux manifestations d'intérêt ou avis de pré-qualification"
        },
        path: "Offers",
        name: "Offers",
        component: Offers,
        redirect: { name: "welcomeOffers" },
        children: [
          {
            path: "",
            name: "welcomeOffers",
            component: welcomeOffers
          },
          {
            meta: {
              breadcrumb: "Aperçu de l' Offre/Proposition/Pli"
            },
            path: ":id",
            name: "showOffers",
            props: true,
            component: showOffers
          }
        ]
      },
      {
        meta: {
          breadcrumb: "LISTE DES SEANCES PUBLIQUES D’OUVERTURES"
        },
        path: "Session",
        name: "Session",
        component: Session,
        redirect: { name: "welcomeSession" },
        children: [
          {
            path: "",
            name: "welcomeSession",
            component: welcomeSession
          },
          {
            meta: {
              breadcrumb: "Aperçu de la séance publique d’ouverture des Offres/Propositions/Plis"
            },
            path: ":id",
            name: "showSession",
            props: true,
            component: showSession
          }
        ]
      },
      {
        meta: {
          breadcrumb: "Création, modification et mise à jour des modèles de dossiers"
        },
        path: "Model_pv",
        name: "Model_pv",
        component: Model_pv,
        redirect: { name: "welcomeModel_pv" },
        children: [
          {
            path: "",
            name: "welcomeModel_pv",
            component: welcomeModel_pv
          },
          {
            meta: {
              breadcrumb: "Page de redaction"
            },
            path: ":id",
            name: "showModel_pv",
            props: true,
            component: showModel_pv
          }
        ]
      },
      {
        path: "entreprises_exclues",
        name: "entreprises_exclues",
        component: entreprises_exclues,
        meta: {
          breadcrumb: 'Liste des entreprises  exclues',
        },
        redirect: { name: "welcome_entreprises_exclues" },
        children: [
          {
            path: "",
            name: "welcome_entreprises_exclues",
            component: welcome_entreprises_exclues
          },
          {
            path: ":id",
            name: "show_entreprises_exclues",
            props: true,
            component: show_entreprises_exclues,
            meta: {
              breadcrumb: 'Détails de l\'entreprise'
            }
          }
        ]
      },
      {
        path: "modele_fiche_quitus",
        name: "modele_fiche_quitus",
        component: modele_fiche_quitus,
        meta: {
          breadcrumb: 'Modèle de Fiche de quitus de non redevance',
        },
        redirect: { name: "welcome_modele_fiche_quitus" },
        children: [
          {
            path: "",
            name: "welcome_modele_fiche_quitus",
            component: welcome_modele_fiche_quitus
          },
          {
            path: ":id",
            name: "show_modele_fiche_quitus",
            props: true,
            component: show_modele_fiche_quitus,
            meta: {
              breadcrumb: 'Détails de la fiche'
            }
          }
        ]
      },
      {
        path: "quitus_non_redevance",
        name: "quitus_non_redevance",
        component: quitus_non_redevance,
        meta: {
          breadcrumb: 'Quitus de non redevance',
        },
        redirect: { name: "welcome_quitus_non_redevance" },
        children: [
          {
            path: "",
            name: "welcome_quitus_non_redevance",
            component: welcome_quitus_non_redevance
          },
          {
            path: ":id",
            name: "show_quitus_non_redevance",
            props: true,
            component: show_quitus_non_redevance,
            meta: {
              breadcrumb: 'Détails du quitus'
            }
          }
        ]
      },
      {
        meta: {
          breadcrumb: "LISTE DES SÉANCES PLÉNIÈRES D’ATTRIBUTIONS DES MARCHES"
        },
        path: "Attribution",
        name: "Attribution",
        component: Attribution,
        redirect: { name: "welcomeAttribution" },
        children: [
          {
            path: "",
            name: "welcomeAttribution",
            component: welcomeAttribution
          },
          {
            meta: {
              breadcrumb: "Aperçu de la séance plénière d’attribution du marché"
            },
            path: ":id",
            name: "showAttribution",
            props: true,
            component: showAttribution
          }
        ]
      },
      {
        meta: {
          breadcrumb: "Liste des séances de negociation"
        },
        path: "Contract",
        name: "Contract",
        component: Contract,
        redirect: { name: "welcomeContract" },
        children: [
          {
            path: "",
            name: "welcomeContract",
            component: welcomeContract
          },
          {
            meta: {
              breadcrumb: "Aperçu de la séance de négociation du marché"
            },
            path: ":id",
            name: "showContract",
            props: true,
            component: showContract
          }
        ]
      },
      {
        meta: {
          breadcrumb: 'Demandes'
        },
        path: "/request",
        name: "request",
        component: requestOffers
      }
    ]
  },
  {
    path: "/representator",
    name: "representator",
    component: representator,
    meta: {
      breadcrumb: 'Vérification par le système du code d’accès du représentant du soumissionnaire à la séance publique d’ouverture (Offres/ Propositions/ Plis)'
    },
    redirect: { name: "welcomeRepresentator" },
    children: [
      {
        path: "",
        name: "welcomeRepresentator",
        component: welcomeRepresentator
      },
      {
        meta: {
          breadcrumb: 'Espace du représentant du soumissionnaire pour la participation à la séance publique d’ouverture (Offres/ Propositions/ Plis)'
        },
        path: ":id",
        name: "showRepresentator",
        props: true,
        component: showRepresentator
      }
    ]
  },
  {
    path: "/password/reset/:token",
    name: "Password_Reset",
    props: true,
    component: PasswordReset,
    meta: {
      title: 'Reinitialisation mot de passe | ICP-E-PROCUREMENT',
      metaTags: [
        {
          name: 'description',
          content: "Reinitialisation de votre mot de passe"
        },
        {
          property: 'og:description',
          content: "Reinitialisation de votre mot de passe"
        }
      ],
      breadcrumb: 'Reinitialisation de votre mot de passe'
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  {
    meta: {
      breadcrumb: 'Liste des recours'
    },
    beforeEnter: guardAdmin,
    path: "/recourse",
    name: "recourse",
    component: Recourse,
    redirect: { name: "welcomeRecourse" },
    children: [
      {
        path: "",
        name: "welcomeRecourse",
        component: welcomeRecourse
      },
      {
        meta: {
          breadcrumb: 'Aperçu Recours'
        },
        path: ":id",
        name: "showRecourse",
        props: true,
        component: showRecourse
      }
    ]
  },
  {
    meta: {
      breadcrumb: 'Liste des avis'
    },
    path: "/public_notice",
    name: "public_notice",
    component: public_notice,
    redirect: { name: "welcome_p_notice" },
    children: [
      {
        path: "",
        name: "welcome_p_notice",
        component: welcome_p_notice
      },
      {
        meta: {
          breadcrumb: 'Aperçu de l’avis publié'
        },
        path: ":id",
        name: "show_p_notice",
        props: true,
        component: show_p_notice
      },
        {
          path: "type/AGPM",
          name: "show_p_notice_by_type1",
          component: noticeType1
        },
        {
          path: "type/AMI",
          name: "show_p_notice_by_type2",
          component: noticeType2
        },
        {
          path: "type/APQ",
          name: "show_p_notice_by_type3",
          component: noticeType3
        },
        {
          path: "type/AAO",
          name: "show_p_notice_by_type4",
          component: noticeType4
        },
        {
          path: "type/ADP",
          name: "show_p_notice_by_type5",
          component: noticeType5
        },
        {
          path: "type/ADD",
          name: "show_p_notice_by_type6",
          component: noticeType6
        }
    ]
  },
  {
    path: "/public_ppm",
    name: "public_ppm",
    component: public_ppm,
    redirect: { name: "welcome_ppm_public" },
    meta: {
      breadcrumb: 'Liste des Plans de Passation des Marchés (PPM)'
    },
    children: [
      {
        path: "",
        name: "welcome_ppm_public",
        component: welcome_ppm_public,
      },
      {
        path: ":id",
        name: "show_p_ppm",
        props: true,
        meta: {
          breadcrumb: 'Aperçu du Plan de Passation des Marchés (PPM)'
        },
        component: show_p_ppm
      }
    ],
  },
  {
    path: "/public_exclusion",
    name: "public_exclusion",
    component: public_exclusion,
    redirect: { name: "welcome_public_exclusion" },
    meta: {
      breadcrumb: 'Liste des entreprises exclues de la commande publique'
    },
    children: [
      {
        path: "",
        name: "welcome_public_exclusion",
        component: welcome_public_exclusion,
      },
      {
        path: ":id",
        name: "show_public_exclusion",
        props: true,
        meta: {
          breadcrumb: 'Aperçu de l\'entreprise exclue'
        },
        component: show_public_exclusion
      }
    ],
  },
  {
    path: "/public_denonciation",
    name: "public_denonciation",
    component: public_denonciation,
    redirect: { name: "welcome_public_denonciation" },
    meta: {
      breadcrumb: 'Liste des dénonciations publiques'
    },
    children: [
      {
        path: "",
        name: "welcome_public_denonciation",
        component: welcome_public_denonciation,
      },
      {
        path: ":id",
        name: "show_public_denonciation",
        props: true,
        meta: {
          breadcrumb: 'Aperçu de la dénonciation'
        },
        component: show_public_denonciation
      }
    ],
  },
  {
    // matches everything else
    path: "*",
    name: "notFound",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  base: process.env.BASE_URL,
  routes
});

// ...

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

// ...

export default router;
